import React, { useState, useEffect } from 'react';
import {
  Card,
  CardContent,
  CardHeader,
  TextField,
  Button,
  Grid,
  MenuItem,
  InputLabel,
  Select,
  FormControl,
  Typography,
  Box,
  Divider,
  Avatar,
  Paper,
  InputAdornment,
  IconButton,
  Container,
  Tooltip
} from '@mui/material';
import {
  Home as HomeIcon,
  Login as LoginIcon,
  HowToReg as RegisterIcon,
  Logout as LogoutIcon,
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Apartment as PropertiesIcon,
  People as OwnersIcon,
  Person as PersonIcon,
  Save as SaveIcon,
  Cancel as CancelIcon
} from '@mui/icons-material';
import { DatePicker } from '@mui/x-date-pickers';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { CloudUpload, Add, Delete } from '@mui/icons-material';
import axios from 'axios';
import { auth, storage } from '../components/Security/firebaseConfig';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import Swal from 'sweetalert2';
import { hideLoading, showLoading } from '../redux/slices/loadingSlice';
import { createProperty, createPropertyImage, createPropertyTrace } from '../actions/PropertyAction';
import { useNavigate } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import useStyles from '../theme/useStyles';

const PropertyForm = () => {
  const navigate = useNavigate();
  const classes= useStyles();
  const [property, setProperty] = useState({
    // id: '0',
    name: '',
    address: '',
    price: '',
    codeInternal: '',
    year: new Date().getFullYear(),
    ownerId: ''
  });

  const [owners, setOwners] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const [traces, setTraces] = useState([{
    date: new Date(),
    name: '',
    value: '',
    tax: 0
  }]);

  useEffect(() => {
    const fetchOwners = async () => {
      try {
        const response = await axios.get('/api/owners');
        setOwners(response.data);
      } catch (error) {
        console.error('Error fetching owners:', error);
        Swal.fire('Error', 'No se pudo cargar la lista de propietarios', 'error');
      }
    };
    
    fetchOwners();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProperty(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleTraceChange = (index, field, value) => {
    const updatedTraces = [...traces];
    updatedTraces[index][field] = value;
    setTraces(updatedTraces);
  };

  const addTrace = () => {
    setTraces([...traces, {
      date: new Date(),
      name: '',
      value: ''
    }]);
  };

  const removeTrace = (index) => {
    if (traces.length > 1) {
      const updatedTraces = [...traces];
      updatedTraces.splice(index, 1);
      setTraces(updatedTraces);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
      // Crear vista previa
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const uploadImage = async () => {
    if (!selectedFile) return null;

    try {
      // 1. Autenticar al usuario con credenciales del .env
      const userCredential = await signInWithEmailAndPassword(
        auth,
        process.env.REACT_APP_FIREBASE_AUTH_EMAIL,
        process.env.REACT_APP_FIREBASE_AUTH_PASSWORD
      );

      console.log("Usuario autenticado:", userCredential.user.uid);

      const storageRef = ref(storage, `property-images/${Date.now()}-${selectedFile.name}`);
      const snapshot = await uploadBytes(storageRef, selectedFile);
      const downloadURL = await getDownloadURL(snapshot.ref);
      // return await getDownloadURL(snapshot.ref);

      // 3. Cerrar sesión (opcional)
      await auth.signOut();

      console.log('downloadURL: ', downloadURL);

      return downloadURL;

    } catch (error) {
      console.error('Error uploading image:', error);
      Swal.fire('Error', 'No se pudo subir la imagen', 'error');
      return null;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    showLoading('Creando propiedad...');
    try {
      // 1. Crear propiedad
      const { success, propertyId } = await createPropertyAsync();
      
      if (success && propertyId) {
        // 2. Subir imagen si la propiedad se creó correctamente y hay imagen seleccionada
        let imageUrl = null;
        if (selectedFile) {
          imageUrl = await uploadImageProperty(propertyId);
          console.log('imagen en repositorio: ', imageUrl)
        }

        // 3. Crear traces si la propiedad se creó correctamente y hay traces
        // if (traces.length > 0 && traces[0].name) {
        //   await createTraces(propertyId);
        // }
        hideLoading();
        Swal.fire('Éxito', 'Propiedad creada correctamente', 'success');
        resetForm();
      } else{
        hideLoading();
        console.error('Error creating property');
        Swal.fire('Error', 'No se pudo crear la propiedad', 'error');
      }
    } catch (error) {
      hideLoading();
      console.error('Error creating property:', error);
      Swal.fire('Error', 'No se pudo crear la propiedad', 'error');
    } finally {
      setLoading(false);
    }
  };

  const createPropertyAsync = async () => {
    // showLoading('Creating property...');
    try {

      const newProperty = {
        ...property,
        id: '0',
        price: parseFloat(property.price),
        year: parseInt(property.year)
      }

      console.log('request property: ', newProperty);
      const response = await createProperty(newProperty);
      console.log('response: ', response);

      // hideLoading();

      if(response.status === 200 || response.status === 201){
        // Swal.fire({
        //     title: 'Property created!',
        //     text: "ID: " + response.data.id + " - " + response.data.name,
        //     icon: 'success',
        // });
        return { success: true, propertyId: response.data.id };
      }
      else{
        hideLoading();
        const errorMessage = response.data?.message || 'Unknown error occurred';
        Swal.fire({
            title: 'Errors creating property',
            text: errorMessage,
            icon: 'warning'
        });
        return { success: false, propertyId: null };
      }
    } catch (error) {
      hideLoading();
      console.error('Unexpected error creating property:', error);
      Swal.fire({
          title: 'Unexpected error!',
          text: 'Please try again later',
          icon: 'error'
      });
      return { success: false, propertyId: null };
    }
  };

  const uploadImageProperty = async (propertyId) => {
    showLoading('Uploading image...');
    if (selectedFile) {
      try {
        const imageUrl = await uploadImage();
        console.log('image url: ', imageUrl);
        if (imageUrl) {
          const newPropertyImage = {
            id: '0',
            propertyId: propertyId,
            file: imageUrl,
            enabled: true
          }

          console.log('request propertImage: ', newPropertyImage);
          const response = await createPropertyImage(newPropertyImage);
          console.log('response image: ', response);

          hideLoading();
          if(response.status === 200){
            Swal.fire({
              title: 'Property image created!',
              text: "ID: " + response.data.id + " - " + response.data.name,
              icon: 'success',
            });
            return { imageUrl };
          }
          else{
            Swal.fire({
              title: 'Errors creating property image',
              text: propertyId,
              icon: 'warning'
            });
            return { imageUrl };
          }
        }
        Swal.fire({
          title: 'Errors creating property image',
          text: 'No se ha podido subir la imagen al repositorio',
          icon: 'warning'
        });
        return null;
      } catch (error) {
        hideLoading();
        console.error('Error uploading image:', error);
        console.error('Unexpected error creating propertyImage:', error);
        Swal.fire({
            title: 'Unexpected error!',
            text: 'Please try again later',
            icon: 'error'
        });
        return null;
      }
    }
  };

  const createTraces = async (propertyId) => {
    showLoading('Saving traces...');
    
    // Filtrar solo traces válidos (con nombre no vacío)
    const validTraces = traces.filter(trace => trace.name.trim() !== '');
    
    if (validTraces.length === 0) {
        hideLoading();
        return true;
    }

    try {
      const results = await Promise.all(
        validTraces.map(async trace => {
          const traceData = {
              id: '0',
              propertyId: propertyId,
              dateSale: trace.date,
              name: trace.name,
              value: trace.value,
              tax: trace.tax || 0
          };
          
          const response = await createPropertyTrace(traceData);
          
          if (response.status !== 200) {
              throw new Error(`Failed to create trace: ${response.statusText}`);
          }
          
          return response.data;
        })
      );

      hideLoading();
      
      // Mostrar feedback de éxito
      if (results.length > 0) {
          Swal.fire({
            title: 'Traces created successfully!',
            text: `Created ${results.length} trace(s)`,
            icon: 'success'
          });
      }
        
      return true;
    } catch (error) {
        hideLoading();
        console.error('Error creating traces:', error);
        Swal.fire({
          title: 'Error creating traces',
          text: 'Some traces could not be saved',
          icon: 'error'
        });
        return false;
    }
  };

  const calculateTotal = (value, tax) => {
    const numericValue = parseFloat(value) || 0;
    const numericTax = parseFloat(tax) || 0;
    const taxAmount = numericValue * (numericTax / 100);
    return (numericValue + taxAmount).toFixed(2);
  };

  const resetForm = () => {
    setProperty({
      name: '',
      address: '',
      price: '',
      codeInternal: '',
      year: new Date().getFullYear(),
      ownerId: ''
    });
    setTraces([{
      date: new Date(),
      name: '',
      value: ''
    }]);
    setSelectedFile(null);
    setPreviewImage(null);
  };

  return (
    <Box sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'flex-start',
      minHeight: '100vh',
      p: 2,
      boxSizing: 'border-box'
    }}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Card className={classes.card}
          sx={{ 
            width: '100%',
            maxWidth: 1200,
            margin: 'auto',
            mt: 4,
            p: 2
          }}
        >
          <Box component="form" onSubmit={handleSubmit}>
            <CardHeader 
              classes={{ title: classes.cardTitle }}
              avatar={
                <PropertiesIcon style={{fontsize: "large", color: "#494949",}} />
              }
              title="Nueva Propiedad" 
              subheader="Digite los datos"
              // titleTypographyProps={{ variant: 'h5', align: 'center' }}
              action={
                <Grid container spacing={1} alignItems="center" justifyContent="center">
                  <Grid item>
                    <Tooltip title="Guardar" arrow classes={{ tooltip: classes.tooltip }}>
                        <IconButton
                          type="submit"
                          variant="contained"
                          color="primary"
                          size="small"
                          className={classes.button}
                        >
                            <SaveIcon />
                        </IconButton>
                    </Tooltip>
                  </Grid>
                  <Grid item>
                    <Tooltip title="Cancelar" arrow classes={{ tooltip: classes.tooltip }}>
                      <IconButton
                          variant="contained"
                          color="secondary"
                          onClick={() => navigate('/')}
                          size="small"
                          className={classes.button}
                      >
                          <CancelIcon />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                </Grid>
              }
              sx={{ 
                '& .MuiCardHeader-title': { fontSize: '1.25rem' },  // Tamaño del título
                pr: 6  // Espacio extra para evitar solapamiento
              }}
              // sx={{ pt: 3, pb: 1 }}
            />
            
            <CardContent sx={{ '&:last-child': { pb: 2 } }}>
              {/* <Box component="form" onSubmit={handleSubmit}> */}
                {/* Sección Información de Propiedad */}
                {/* <Box sx={{ mb: 3 }}> */}
                  <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold', mb: 2 }}>
                    Información de la Propiedad
                  </Typography>
                  
                  {/* Fila 1 */}
                  {/* <Grid container spacing={2} sx={{ width: '100%', mb: 2, '&:last-child': { mb: 0 } }}> */}
                  <Grid container spacing={2}>
                    <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                      <TextField
                        fullWidth
                        size="small"
                        label="Nombre"
                        name="name"
                        value={property.name}
                        onChange={handleChange}
                        required
                      />
                    </Grid>
                    
                    <Grid size={{ xs: 12, sm: 6, md: 2 }}>
                      <TextField
                        fullWidth
                        size="small"
                        label="Código Interno"
                        name="codeInternal"
                        value={property.codeInternal}
                        onChange={handleChange}
                        required
                      />
                    </Grid>
                    
                    <Grid size={{ xs: 12, sm: 6, md: 2 }}>
                      <TextField
                        fullWidth
                        size="small"
                        label="Precio"
                        name="price"
                        type="number"
                        value={property.price}
                        onChange={handleChange}
                        required
                        inputProps={{ step: "0.01" }}
                      />
                    </Grid>
                    
                    <Grid size={{ xs: 12, sm: 6, md: 2 }}>
                      <TextField
                        fullWidth
                        size="small"
                        label="Año de construcción"
                        name="year"
                        type="number"
                        value={property.year}
                        onChange={handleChange}
                        required
                      />
                    </Grid>
                    
                    <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                      <FormControl fullWidth size="small" required >
                        <InputLabel id="owner-select-label">Propietario</InputLabel>
                        <Select
                          labelId="owner-select-label"
                          name="ownerId"
                          value={property.ownerId}
                          onChange={handleChange}
                          label="Propietario"
                          sx={{ 
                            textAlign: 'left',
                            '& .MuiSelect-select': {
                              width: '100%',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis'
                            }
                          }}
                        >
                          {owners.map(owner => (
                            <MenuItem 
                              key={owner.id} 
                              value={owner.id}
                              sx={{
                                whiteSpace: 'normal',
                                wordBreak: 'break-word'
                              }}
                            >
                              {owner.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>

                  </Grid>
                  
                  {/* Dirección (fila completa) */}
                  <Grid container sx={{ mt: 2 }}>
                    <Grid size={{ xs: 12, sm: 12, md: 12 }}> 
                      <TextField
                        fullWidth
                        size="small"
                        label="Dirección"
                        name="address"
                        value={property.address}
                        onChange={handleChange}
                        required
                        multiline
                        rows={2} 
                        sx={{
                          width: '100%',
                          '& .MuiOutlinedInput-root': {  /* Estilo para el contenedor interno */
                            alignItems: 'flex-start' /* Alinea el texto arriba en multilínea */
                          }
                        }}
                      />
                    </Grid>
                  </Grid>
                {/* </Box> */}
                
                <Divider sx={{ my: 2 }} />
                
                {/* Sección Imágenes */}
                <Box sx={{ mb: 3 }}>
                  <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold', mb: 2 }}>
                    Imágenes de la Propiedad
                  </Typography>
                  
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <Button
                        component="label"
                        variant="outlined"
                        startIcon={<CloudUpload />}
                        fullWidth
                        // sx={{ height: 120 }}
                      >
                        Seleccionar Imagen
                        <input
                          type="file"
                          hidden
                          onChange={handleFileChange}
                          accept="image/*"
                        />
                      </Button>
                    </Grid>
                    
                    <Grid item xs={12} md={6}>
                      <Box sx={{ 
                        height: 120,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        border: '1px dashed',
                        borderColor: 'divider',
                        borderRadius: 1,
                        overflow: 'hidden',
                        backgroundColor: 'action.hover'
                      }}>
                        {previewImage ? (
                          <img 
                            src={previewImage} 
                            alt="Preview" 
                            style={{ width: '100%', height: '100%', objectFit: 'cover' }} 
                          />
                        ) : (
                          <Typography variant="caption" color="text.secondary">
                            Vista previa de imagen
                          </Typography>
                        )}
                      </Box>
                    </Grid>
                    
                    {selectedFile && (
                      <Grid item xs={12}>
                        <Typography variant="caption" display="block" sx={{ mt: 1 }}>
                          Archivo seleccionado: {selectedFile.name}
                        </Typography>
                      </Grid>
                    )}
                  </Grid>
                </Box>
                
                <Divider sx={{ my: 2 }} />
                
                
            </CardContent>
          </Box>
        </Card>
      </LocalizationProvider>
    </Box>
  );
};

export default PropertyForm;